import { Formik } from 'formik';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import LabelRequired from '../../component/LabelRequired';
import TextField from '../../component/TextField';
import { RESPONSE_STATUS_CODE } from '../../utils/Constant';
import { initKetLuan } from '../const/constants';
import { IKetLuanSCYK } from '../models/BaoCaoSCYKModels';
import { ketLuanSCYK } from '../services/BaoCaoSCYKServices';
import Autocomplete from './../../component/input-field/Autocomplete';
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';

type Props = {
    handleClose: () => void
    suCoId: string
    updatePageData: (objectSearch: any) => void;
}

const KetLuanSCYKDialog = ({ handleClose, suCoId, updatePageData }: Props) => {

    const validationSchema = Yup.object().shape({
        lyDo: Yup.string().required("Bắt buộc nhập"),
        tenNguoiKetLuan: Yup.string().required("Bắt buộc nhập"),
        khoaPhong: Yup.string().required("Bắt buộc chọn"),
        chucDanh: Yup.string().required("Bắt buộc chọn"),
    });

    const handleSubmit = async (values: IKetLuanSCYK) => {
        values.suCoId = suCoId
        try {
            const { data: { code } } = await ketLuanSCYK(values)
            if (code === RESPONSE_STATUS_CODE.CREATED) {
                toast.success("Kết luận báo cáo SCYK thành công.");
                updatePageData({})
                handleClose()
            }

        } catch (error) {
            toast.error(String(error));
        }
    }

    return (
        <Modal show={true} onHide={handleClose} centered size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Kết luận sự cố y khoa</Modal.Title>
            </Modal.Header>
            <Formik
                validationSchema={validationSchema}
                initialValues={initKetLuan}
                onSubmit={handleSubmit}
            >
                {({
                    errors,
                    values,
                    touched,
                    setFieldValue,
                    handleSubmit,
                }) => {

                    return (
                        <form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col xs={6}>
                                        <div className="spaces pb-4">
                                            <LabelRequired
                                                className="text-primary spaces fw-700 h-24 mb-4"
                                                label="Lý do kết luận"
                                                isRequired
                                            />
                                            <TextField
                                                className="spaces"
                                                name="lyDo"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="spaces pb-4">
                                            <LabelRequired
                                                className="text-primary spaces fw-700 h-24 mb-4"
                                                label="Người kết luận"
                                                isRequired
                                            />
                                             <TextField
                                                className="spaces"
                                                name="tenNguoiKetLuan"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="spaces pb-4">
                                            <LabelRequired
                                                className="text-primary spaces fw-700 h-24 mb-4"
                                                label="Khoa/Phòng"
                                                isRequired
                                            />
                                            <Autocomplete
                                                onChange={(selectedOption) => setFieldValue("khoaPhong", selectedOption?.id)}
                                                className="spaces h-25 width-100"
                                                name="khoaPhong"
                                                options={localStorageItem.get(KEY_LOCALSTORAGE.LIST_PHONG_BAN)}
                                                value={values?.khoaPhong}
                                                errors={errors?.khoaPhong}
                                                touched={touched?.khoaPhong}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="spaces pb-4">
                                            <LabelRequired
                                                className="text-primary spaces fw-700 h-24 mb-4"
                                                label="Chức danh"
                                                isRequired
                                            />
                                            <Autocomplete
                                                onChange={(selectedOption) => setFieldValue("chucDanh", selectedOption?.id)}
                                                className="spaces h-25 width-100"
                                                name="chucDanh"
                                                options={localStorageItem.get(KEY_LOCALSTORAGE.LIST_CHUC_DANH)}
                                                value={values?.chucDanh}
                                                errors={errors?.chucDanh}
                                                touched={touched?.chucDanh}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <div className="spaces pb-4">
                                            <LabelRequired
                                                className="text-primary spaces fw-700 h-24 mb-4"
                                                label="Ghi chú"
                                            />
                                            <TextField
                                                className="spaces"
                                                name="ghiChu"
                                                as="textarea"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                            </Modal.Body>
                            <Modal.Footer className="d-flex justify-content-center">
                                <Button
                                    className="button-primary"
                                    type='submit'
                                >
                                    Lưu
                                </Button>
                                <Button
                                    className="button-gray"
                                    onClick={handleClose}
                                >
                                    Hủy
                                </Button>
                            </Modal.Footer>
                        </form>
                    );
                }}
            </Formik>
        </Modal>
    )
}

export default KetLuanSCYKDialog